
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './auth/App';
import * as serviceWorker from './serviceWorker';
import store from './configureStore';
import { Provider } from 'react-redux';
import { getValidUser } from './auth/AuthService';
import { setUser } from './actions/actionsBase';
import { actionTypes } from './types/enums';
import { userManager } from './auth/Auth';

const apiUrl = "__API_URL__";
const tag = "__APP_VERSION__";
console.log(`API_URL: ${apiUrl}, TAG: ${tag}`);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

// ✅ Bootstrap before rendering app
async function bootstrap() {
  try {
    const user = await getValidUser();

    if (user) {
      store.dispatch(setUser(actionTypes.SET_USER, user));
    }
  
    // ✅ Sync Redux when user is loaded (login or refresh)
    userManager.events.addUserLoaded((user) => {
      console.log("User loaded (event)");
      store.dispatch(setUser(actionTypes.SET_USER, user));
    });

    // ✅ Sync when user is removed (logout)
    userManager.events.addUserUnloaded(() => {
      console.log("User logged out");
      store.dispatch(setUser(actionTypes.SET_USER, null));
    });
    
    userManager.events.addSilentRenewError((err) => {
        console.error("Silent renew failed", err);
        // ✅ Optional: force logout
        // userManager.signoutRedirect();
    });


  } catch (err) {
    console.error('Auth bootstrap failed', err);
  }

  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}

bootstrap();

// service worker
serviceWorker.unregister();
